/**
 * 묶음 R-B(R130, DESIGN 14.455) — 공성전 소집 카운트다운.
 *
 * 공성전(진짜·모의)이 확정되면 사냥터에 접속해 있는 신청자에게 서버가 `siegeRecall { at, text }` 를 보낸다
 * (`src/world/siege-recall.ts` `noticeSiegeRecall` — 사냥터 우편함, 파티 확인 길). 이 모듈은 화면 위쪽 가운데에
 * 「⚔ 공성전 전장으로 N초 뒤 불려 간다」를 1초마다 줄여 보인다. 시각이 되면 서버가 사냥터에서 마을로 불러오고(기존 귀환 인계)
 * 도착하면 곧바로 전장에 세운다 — 마을로 옮겨지는 순간(`fieldReturn`) 이 표시는 사라진다.
 *
 * **절대규칙 4(io 기준선) — 입력을 막지 않는다**: `pointer-events:none`. 같은 줄은 기록(`log`)에도 한 번 남는다(서버가 같이 보낸다).
 * `siegeRecallText` 는 DOM 을 안 만지는 순수 함수다.
 */

/** 남은 시간 글자 — `at`(초, 서버 시각)까지 남은 초. 지났으면 「불러오는 중」. */
export function siegeRecallText(at, nowSec) {
  const secs = Math.max(0, Math.ceil(Number(at) - Number(nowSec)));
  return secs > 0 ? `⚔ 공성전 전장으로 ${secs}초 뒤 불려 간다` : '⚔ 공성전 전장으로 불러오는 중…';
}

let timer = 0;
let bar = null;

function stop() {
  if (timer) clearInterval(timer);
  timer = 0;
  bar?.remove();
  bar = null;
}

/** main.js 의 `siegeRecall` 수신 훅. 같은 알림이 다시 오면 새 시각으로 다시 센다. */
export function showSiegeRecall(m) {
  const at = Number(m?.at);
  if (!Number.isFinite(at) || typeof document === 'undefined') return;
  stop();
  bar = document.createElement('div');
  bar.id = 'siegeRecallBar';
  bar.setAttribute('role', 'status');
  Object.assign(bar.style, {
    position: 'fixed', top: '64px', left: '50%', transform: 'translateX(-50%)', zIndex: '40', pointerEvents: 'none',
    padding: '6px 14px', borderRadius: '6px', background: 'rgba(40,20,10,.86)', color: '#ffe2a8',
    border: '1px solid #b8862f', fontWeight: '600', fontSize: '14px', maxWidth: 'calc(100vw - 32px)', textAlign: 'center',
  });
  document.body.appendChild(bar);
  const draw = () => {
    const now = Date.now() / 1000;
    // 불러오는 시각이 지나고도 마을로 옮겨지지 않았으면(쓰러짐·이동 중 — 서버가 까닭을 기록에 남긴다) 잠시 뒤 지운다
    if (!bar || now > at + 20) { stop(); return; }
    bar.textContent = siegeRecallText(at, now);
  };
  draw();
  timer = setInterval(draw, 1000);
}

/** 마을로 옮겨졌다(`fieldReturn`) — 표시를 지운다. */
export function clearSiegeRecall() { stop(); }
